import React from 'react';

import { AddButton } from '../../../../components/Button';
import CommonDataGrid from '../../../../components/CommonDataGrid';
import { Column } from '../../../../components/CommonDataGrid/props';
import Loader from '../../../../components/Loader';
import DeleteImg from '../../../../images/SideBar/Delete';
import EditImg from '../../../../images/SideBar/Edit';
import EmailIcon from '../../../../images/SideBar/EmailIcon';
import { formatDate, leadStyes, styles } from '../../../../util/constant';
import useClient from '../useClient';
import EditClientIndex from './EditClient/index';
import EmailModal from './EmailModal';

const Client: React.FC = () => {
  const {
    selectedClientId,
    clientData,
    showConfirmation,
    handleCancelStatusUp,
    updateScreen,
    handleConfirmStatusUp,
    handleEdit,
    handleAdd,
    handleStatusUp,
    handleDateFilter,
    setSearch,
    setPage,
    page,
    loading,
    totalPage,
    openEmailModal,
    handleSendEmail,
    handleSendComment,
    handleSelectAll,
    handleSelectStatus,
    selectedRows,
    handleRowSelection,
    isEmailModalOpen,
    setIsEmailModalOpen,
    setSelectedClientForEmail,
    selectedClientForEmail,
  } = useClient();
  const columns: Column[] = [
    // {
    //   field: "select",
    //   headerName: "Select",
    //   width: 50,
    //   align: "center",
    //   renderCell: (params: any) => (
    //     <div className="flex items-center justify-center">
    //       <input
    //         type="checkbox"
    //         checked={
    //           selectedRows.length > 0
    //             ? selectedRows[0] == "68144e2bc9b56fe1cb8026a6"
    //               ? true
    //               : false
    //             : false
    //         }
    //         onChange={() => handleRowSelection(params.row._id)}
    //         className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
    //         style={{ appearance: "auto" }}
    //       />
    //     </div>
    //   ),
    // },
    {
      field: "userId",
      headerName: "creator Name",
      width:50,
      renderCell: (params: any) => <p>{params.value?.name}</p>
    },
    {
      field: "name",
      headerName: "Client Name",
      width: 50,
      align: "center",
    },
    {
      field: "description",
      headerName: "Description",
      width: 50,
      align: "center",
    },
    {
      field: "email",
      headerName: "Email",
      width: 50,
      align: "center",
    },
    {
      field: "phone",
      headerName: "phone",
      width: 50,
      align: "center",
    },
    {
      field: "companyName",
      headerName: "companyName",
      width: 50,
      align: "center",
    },
    {
      field: "platform",
      headerName: "platform",
      renderCell: (params: any) => <p>{params.value?.name}</p>,
      width: 50,
      align: "center",
    },
    {
      field: "interest",
      headerName: "interest",
      renderCell: (params: any) => <p>{params.value?.type}</p>,
      width: 50,
      align: "center",
    },
    {
      field: "services",
      headerName: "services",
      renderCell: (params: any) => <p>{params.value?.type}</p>,
      width: 50,
      align: "center",
    },
    {
      field: "outputStatus",
      headerName: "output Status",
      renderCell: (params: any) => <p>{params.value?.status}</p>,
      width: 50,
      align: "center",
    },
    {
      field: "linkedin",
      headerName: "Linkedin",
      renderCell: (params: any) => (
        <a
          className="text-blue-500 border-b-2 border-blue-500 cursor-pointer"
          href={params.value}
          target="_blank"
          rel="noopener noreferrer"
        >
          Link
        </a>
      ),
      width: 120,
      align: "center",
    },
    {
      field: "createdAt",
      headerName: "createdAt",
      renderCell: (params: any) => <p>{formatDate(params.value)}</p>,
      width: 50,
      align: "center",
    },
    {
      field: "status",
      renderCell: (params: any) => (
        <p className={`${styles[params.value]}`}>{params.value}</p>
      ),
      headerName: "Status",
      width: 50,
      align: "center",
    },
    {
      field: "Actions",
      headerName: "Actions",
      width: 50,
      align: "center",
      renderCell: (params: any) => (
        <div className="flex space-x-2 justify-center">
          <button
            onClick={() => handleEdit(params.row._id)}
            className="text-fontColor hover:text-primary-2"
          >
            <EditImg />
          </button>
          <button
            onClick={() => handleStatusUp(params.row._id)}
            className="text-red-500 hover:text-red-700"
          >
            <DeleteImg />
          </button>
          <button
            onClick={() => openEmailModal(params.row._id)}
            className="text-blue-500 hover:text-blue-700"
          >
            <EmailIcon />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <div className="m-5 h-[80vh] overflow-auto">
        {loading && <Loader />}
        <div>
          {selectedClientId ? (
            <EditClientIndex
              clientId={selectedClientId}
              setMethod={() => updateScreen("edit")}
            />
          ) : (
            <>
              <div className="flex items-center space-x-2">
                {/* <div className="flex items-center space-x-2">
                  <input
                    type="checkbox"
                    checked={selectedRows.length === clientData.length}
                    onChange={handleSelectAll}
                    className="ml-5"
                  />
                  <Button
                    className="p-3"
                    onClick={() => openEmailModal()}
                    type="button"
                  >
                    <EmailIcon />
                  </Button>
                  {selectedRows.length > 0 && (
                    <span className="text-sm text-gray-600">
                      {selectedRows.length} selected
                    </span>
                  )}
                </div> */}
              </div>
              <div className="grid justify-items-end -mb-16 mr-5">
                <AddButton
                  onClick={handleAdd}
                  className=""
                  children="+"
                  type="button"
                />
              </div>
              <CommonDataGrid
                tableName="Client"
                rows={clientData}
                columns={columns}
                getRowId={(row) => row._id}
                showConfirmation={showConfirmation}
                confirmationMessage="Are you sure you want to Status Update this Client?"
                onCancelDelete={handleCancelStatusUp}
                onConfirmDelete={handleConfirmStatusUp}
                loading={!clientData}
                onDateFilter={handleDateFilter}
                addButton
                setSearchBar={setSearch}
                setCurrentPage={setPage}
                currentPage={page}
                totalPages={totalPage}
                downloadCSVFilter={false}
              />
              <EmailModal
                isOpen={isEmailModalOpen}
                onClose={() => {
                  setIsEmailModalOpen(false);
                  setSelectedClientForEmail(null);
                }}
                onSendMail={handleSendEmail}
                onSend={handleSendComment}
                leadStatus={
                  selectedClientForEmail
                    ? clientData.find(
                        (client) => client._id === selectedClientForEmail
                      )?.leadStatus || ""
                    : ""
                }
                selectedCount={selectedClientForEmail ? 1 : selectedRows.length}
                selectedClientId={selectedClientForEmail}
              />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Client;
